import React, { useState } from 'react';

// Lead avatar: the Messenger / Instagram profile photo captured on inbound
// (customFields.profile_pic, set in server/services/inboundMessage.js),
// falling back to gradient initials when there is no photo or the Meta CDN
// URL no longer loads. Accepts a lead or an Inbox row — anything with
// firstName / lastName and either customFields or a flat profilePic.
const LeadAvatar = ({ lead, size = 40, className = '' }) => {
  const [broken, setBroken] = useState(false);
  const cf = lead?.customFields instanceof Map
    ? Object.fromEntries(lead.customFields)
    : (lead?.customFields || {});
  const pic = lead?.profilePic || cf.profile_pic;
  const initials = `${(lead?.firstName?.[0] || '?').toUpperCase()}${(lead?.lastName?.[0] || '').toUpperCase()}`;

  if (pic && !broken) {
    return (
      <img
        src={pic}
        alt={initials}
        referrerPolicy="no-referrer"
        className={`flex-shrink-0 rounded-full object-cover bg-gray-100 ${className}`}
        style={{ width: size, height: size }}
        onError={() => setBroken(true)}
      />
    );
  }
  return (
    <div
      className={`flex-shrink-0 rounded-full bg-gradient-to-br from-primary-400 to-primary-600 text-white flex items-center justify-center font-bold ${className}`}
      style={{ width: size, height: size, fontSize: size * 0.36 }}
    >
      {initials}
    </div>
  );
};

export default LeadAvatar;
